import {useMatchMedia} from '@pexip/hooks';

import {MD} from '../../constants/mediaQueries';

export const useMd = () => useMatchMedia(MD);
